/** Текст начинается с тега — считаем HTML (как из админки WYSIWYG), иначе Markdown. */
export function agreementContentLooksLikeHtml(raw: string): boolean {
  const t = raw.trim();
  if (!t.startsWith('<')) return false;
  return /^<[a-z!/]/i.test(t);
}
